type Kpi = { label: string; value: string; hint?: string };
type Bar = { label: string; value: number; color?: string };

export function KpiGrid({ kpis }: { kpis: Kpi[] }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {kpis.map((k) => (
        <div key={k.label} className="border border-[var(--rule)] rounded-sm bg-[var(--paper)] p-5">
          <div className="eyebrow text-[var(--leaf)] mb-2">{k.label}</div>
          <div className="font-display text-2xl md:text-3xl text-[var(--ink)]">{k.value}</div>
          {k.hint && <div className="text-xs text-[var(--ink)]/60 mt-1">{k.hint}</div>}
        </div>
      ))}
    </div>
  );
}

export function BarChart({ bars, max }: { bars: Bar[]; max?: number }) {
  const m = max ?? Math.max(...bars.map((b) => b.value), 1);
  return (
    <div className="space-y-2.5">
      {bars.map((b) => (
        <div key={b.label} className="flex items-center gap-3">
          <div className="w-40 shrink-0 text-sm text-[var(--ink)]/75">{b.label}</div>
          <div className="flex-1 h-3 bg-[var(--cloud)] rounded-sm overflow-hidden">
            <div
              className="h-full rounded-sm"
              style={{
                width: `${(b.value / m) * 100}%`,
                background: b.color ?? "var(--leaf)",
              }}
            />
          </div>
          <div className="w-24 text-right text-sm font-medium text-[var(--ink)] tabular-nums">{b.value.toLocaleString("de-DE")}</div>
        </div>
      ))}
    </div>
  );
}

export function ReportSection({
  title,
  children,
  eyebrow,
}: {
  title: string;
  eyebrow?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="border border-[var(--rule)] rounded-sm bg-[var(--paper)] p-6 md:p-8">
      {eyebrow && <div className="eyebrow text-[var(--leaf)] mb-2">{eyebrow}</div>}
      <h3 className="font-display text-xl md:text-2xl text-[var(--ink)] mb-4">{title}</h3>
      {children}
    </section>
  );
}
